import type { Breakpoints, Mixins } from '@mui/material';
import type { Spacing } from '@mui/system';

// We should be able to use the mixin in both sx prop and styled() utility
export type CSSProperties = Mixins['toolbar'];

export function addMixins<T extends { mixins: Mixins; breakpoints: Breakpoints; spacing: Spacing }>(theme: T): T {
  return {
    ...theme,
    mixins: {
      ...theme.mixins,

      /**
       * Page gutters
       *
       * Apply this mixin to page content to align it with the app bar. It sets left and right padding.
       */
      gutters: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        // Do not remove the 'sm' breakpoint with duplicated styles - it is required for AppBarLayout > Toolbar gutters.
        // We also want developers to expect this mixin can contain media queries. Gutters may change in future.
        [theme.breakpoints.up('sm')]: {
          paddingLeft: theme.spacing(2),
          paddingRight: theme.spacing(2),
        },
        [theme.breakpoints.up('md')]: {
          paddingLeft: theme.spacing(2),
          paddingRight: theme.spacing(2),
        },
      } as CSSProperties,

      /**
       * CSS variables for page gutters
       *
       * Use these to align the app bar with page content.
       *
       * Unlike mixins.gutters, these can be used with CSS properties other than inline
       * padding.
       */
      gutterVariables: {
        '--app-gutter-left': theme.spacing(2),
        '--app-gutter-right': theme.spacing(2),
        // See comments above regarding the duplication
        [theme.breakpoints.up('sm')]: {
          '--app-gutter-left': theme.spacing(2),
          '--app-gutter-right': theme.spacing(2),
        },
      } as CSSProperties,

      // Not used in MDS
      toolbar: {},
    },
  };
}
